var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"flat":"","max-height":"56"}},[_c('v-btn',{attrs:{"disabled":_vm.disabled,"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.svg.mdiClose)+" ")])],1),_c('v-toolbar-title',{staticClass:"pl-0"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }